import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { TerminalProfileEntity } from "../../types/TerminalProfileEntity";
import { TerminalProfileDtoToEntity } from "../mappers/TerminalProfileDtoToEntity";
import { TerminalProfileEntityToDto } from "../mappers/TerminalProfileEntityToDto";

const TerminalProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        TerminalProfileLoad: builder.query<TerminalProfileEntity, FormQuery>({
            providesTags: [ResourceName.TERMINAL_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return TerminalProfileDtoToEntity(response);
            },
        }),
        TerminalProfileSave: builder.mutation<TerminalProfileEntity, FormMutation<TerminalProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_PROFILES}`;
                const method = "POST";

                const body = TerminalProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.TERMINAL_PROFILES],
        }),
        TerminalProfileUpdate: builder.mutation<TerminalProfileEntity, FormMutation<TerminalProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = TerminalProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.TERMINAL_PROFILES],
        }),
    }),
});

export const { useTerminalProfileLoadQuery, useTerminalProfileSaveMutation, useTerminalProfileUpdateMutation } = TerminalProfileApi;
